export class MfSgEquipmentListingEntity {
  rowID!: string;
  additionalInfo!: string;
  equipmentDescription!: string;
  equipmentType!: any;
  sumInsured: number = 0;
  typeOfFinancing!: string;
}
